"use strict";
exports.__esModule = true;
exports.getFlagPath = exports.timelineData = void 0;
var dateutil_1 = require("./dateutil");
exports.timelineData = [
    {
        label: "Timmy O'Toole synths Youtube Channel",
        startDate: (0, dateutil_1.toTs)("2017-01-01"),
        endDate: (0, dateutil_1.toTs)("2021-01-01"),
        type: "YOUTUBE",
        line: 0,
        description: "I created a Youtube channel about synthesizers. Showing tips and tricks on how to craft sounds.<br/><br/><a target='_blank' href='https://www.youtube.com/timmyotoole5'>Youtube</a>",
        place: "Brussels",
        country: "Belgium"
    },
    {
        label: "Monstres B Prod",
        startDate: (0, dateutil_1.toTs)("2018-01-01"),
        endDate: (0, dateutil_1.toTs)("2023-01-01"),
        type: "FILM_PROD",
        line: 1,
        description: "We started off writing, directing and producing <a target='_blank' href='https://www.youtube.com/watch?v=0gTdkHNUlR8&list=PL2jG_yWKkayQKmEnf-MDymj8qRGTyRNPZ'>monster movies</a> with some friends. But over time it shifted to more real-life experiments:<br><ul><li><a target='_blank' href='https://www.youtube.com/playlist?list=PL2jG_yWKkaySWm0SUfcDY7ftFcA2pNSma'>Crossing Belgium in a straight line</a></li><li><a target='_blank' href='https://www.instagram.com/p/Cdo4RngDnzL/'>Creating a religion around the movie Free Willy</a></li><li><a target='_blank' href='https://www.youtube.com/watch?v=c09N7Rf9RPI'>Spectro+: Free energy from the undead</a></li></ul><br/>I composed the soundtrack for all these projects.<br/><br/><a target='_blank' href='https://www.monstresbprod.be'>Web site</a><br/><a target='_blank' href='https://www.youtube.com/@monstresbprod4591'>Youtube</a>",
        place: "Brussels",
        country: "Belgium"
    },
    {
        label: "OneLittleSynthesizer",
        startDate: (0, dateutil_1.toTs)("2018-10-01"),
        endDate: (0, dateutil_1.toTs)("2020-01-01"),
        type: "AUDIO_PLUGIN",
        line: 2,
        description: "I created my own synthesizer plugin in C++ using JUCE. <br/><a target='_blank' href='https://github.com/GuillaumeElias/OneLittleSynthesizer'>Github</a>"
    },
    {
        label: "Midi to Text animator",
        startDate: (0, dateutil_1.toTs)("2020-02-01"),
        endDate: (0, dateutil_1.toTs)("2020-05-01"),
        type: "AUDIO_PLUGIN",
        line: 2,
        description: "I created a plugin to display texts based on midi events.<br/><a target='_blank' href='https://github.com/GuillaumeElias/MidiNoteToTextAnimator'>Github</a>"
    },
    {
        label: "Nutekt-MOSC",
        startDate: (0, dateutil_1.toTs)("2020-07-01"),
        endDate: (0, dateutil_1.toTs)("2020-09-01"),
        type: "AUDIO_PLUGIN",
        line: 2,
        description: "I created a custom oscillator for the Korg Nutekt NTS-1.<br/><a target='_blank' href='https://github.com/GuillaumeElias/Nutekt-MOSC'>Github</a>"
    },
    {
        label: "Rue des glands",
        startDate: (0, dateutil_1.toTs)("2021-02-01"),
        endDate: (0, dateutil_1.toTs)("2021-05-01"),
        type: "FILM_WORK",
        line: 0,
        description: "I worked as an actor a on short film called 'Rue des Glands'. <br/> <br/>Directed by Etienne Bloc & Audrey Guibert. <br/><br/> <a target='_blank' href='https://legenerique.be/film/30'>More info</a> <br/> <br/> Team Tchin Prod",
        place: "Brussels",
        country: "Belgium"
    },
    {
        label: "Alien Kermesse",
        startDate: (0, dateutil_1.toTs)("2021-07-01"),
        endDate: (0, dateutil_1.toTs)("2021-10-01"),
        type: "FILM_WORK",
        line: 0,
        description: "I worked as an actor a on a TV-series called Alien Kermesse financed by the RTBF.<br/><br/><a target='_blank' href='https://rtbfcreative.be/programme/-1715854888'>Watch here</a> <br/> <br/> Directed by Maxime Dambly & Manon Henry. <br/> <br/> Part of <a target='_blank' href='https://www.bigtrouble.be/'>Big Trouble Production</a>",
        place: "Brussels",
        country: "Belgium"
    },
    {
        label: "Développé Couché ",
        startDate: (0, dateutil_1.toTs)("2022-03-01"),
        endDate: (0, dateutil_1.toTs)("2022-06-01"),
        type: "FILM_WORK",
        line: 0,
        description: "I worked as an actor and a composer on a short film directed by Audrey Guibert<br/><br/><a target='_blank' href='https://legenerique.be/film/29'>More info here</a>",
        place: "Brussels",
        country: "Belgium"
    },
    {
        label: "No Exceptions",
        startDate: (0, dateutil_1.toTs)("2024-10-01"),
        endDate: (0, dateutil_1.toTs)("2024-12-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "I worked as a sound-recordist on a short film called <a target='_blank' href='https://www.instagram.com/p/DGn6d23JfpH/'>No Exceptions</a> <br/> <br/> Directed by Nathan George and produced by Charlie Osler<br/> <br/> Part of <a target='_blank' href='https://www.instagram.com/nobrunchclub/'>No Brunch Club Productions</a>",
        place: "Toronto",
        country: "Canada"
    },
    {
        label: "All About Mia",
        startDate: (0, dateutil_1.toTs)("2025-01-01"),
        endDate: (0, dateutil_1.toTs)("2025-03-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "I worked as a sound-recordist on a short film called All About Mia <br/> <br/> Directed and produced by Charlie Osler<br/> <br/> Part of <a target='_blank' href='https://www.instagram.com/nobrunchclub/'>No Brunch Club Productions</a>",
        place: "Toronto",
        country: "Canada"
    },
    {
        label: "The End",
        startDate: (0, dateutil_1.toTs)("2025-02-01"),
        endDate: (0, dateutil_1.toTs)("2025-04-01"),
        type: "SOUND_PROD",
        line: 2,
        description: "I worked as a paid sound-recordist on a short film called The End, directed by Olivia Berkowitz and Molly Cole, produced by Emilia Michalowska.",
        place: "Toronto",
        country: "Canada"
    },
    {
        label: "Stand-up",
        startDate: (0, dateutil_1.toTs)("2021-01-01"),
        endDate: (0, dateutil_1.toTs)("2024-06-01"),
        type: "COMEDIAN",
        line: 2,
        description: "I performed regularly as a stand-up comedian in multiple countries. I performed in clubs such as <ul><li>Le Terminal, Montreal</li><li>Le Bordel, Montreal</li><li>Yuk Yuk's Toronto</li><li>Absolute comedy Toronto</li><li>Roes comedy club, Ghent</li><li>Kings of Comedy, Brussels</li><li>RITCS, Brussels</li></ul><br/>You can find clips of my set <a target='_blank' href='https://www.instagram.com/timmy_o_toole/'>here</a>."
    },
    {
        label: "FRENCHY",
        startDate: (0, dateutil_1.toTs)("2023-12-01"),
        endDate: (0, dateutil_1.toTs)("2025-04-01"),
        type: "FILM_PROD",
        line: 1,
        description: "I have been writing, directing and producing a pilot for a show called Frenchy along with Aidan Wright, Director of Photography. <br/><br/> <a target='_blank' href='https://frenchy.timmyotoole.art/?password=notfrench' >Watch it here</a> <br/> <br/> Part of <a target='_blank' href='https://www.instagram.com/nobrunchclub/'>No Brunch Club Productions</a>",
        place: "Toronto",
        country: "Canada"
    },
    {
        label: "Acceptance",
        startDate: (0, dateutil_1.toTs)("2025-05-01"),
        endDate: (0, dateutil_1.toTs)("2025-07-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "I worked as a paid sound recordist on a short film called \"Acceptance\", directed by Imane Hajouji.",
        place: "Montréal",
        country: "Canada"
    },
    {
        label: "Capoté ben Raide",
        startDate: (0, dateutil_1.toTs)("2025-09-01"),
        endDate: (0, dateutil_1.toTs)("2025-12-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "I worked as a sound-recordist on the shoot of \"Capoté ben Raide\", a short film directed by Dougy Hérard.",
        place: "Montréal",
        country: "Canada"
    },
    {
        label: "The Beast We Hunt",
        startDate: (0, dateutil_1.toTs)("2026-02-01"),
        endDate: (0, dateutil_1.toTs)("2026-05-01"),
        type: "SOUND_PROD",
        line: 0,
        description: "I worked as a sound-recordist on the shoot of \"The Beast We Hunt\", a fantasy short film shot entirely in a studio, directed by Arthur Beauchet.",
        place: "Montréal",
        country: "Canada"
    },
    {
        label: "Fiasco",
        startDate: (0, dateutil_1.toTs)("2026-03-15"),
        endDate: (0, dateutil_1.toTs)("2026-06-01"),
        type: "SOUND_PROD",
        line: 2,
        description: "I worked as a sound-recordist on the shoot of \"Fiasco\", a short film directed by Adrien Lessard.",
        place: "St-Hyacinthe",
        country: "Canada"
    },
];
var getFlagPath = function (event) {
    if (event.flagFilename && event.flagFilename.length > 0) {
        return "images/".concat(event.flagFilename, ".gif");
    }
    if (event.country) {
        if (event.country.startsWith("[")) {
            return event.country;
        }
        else {
            return "images/".concat(event.country.toLowerCase(), ".gif");
        }
    }
    else {
        return "";
    }
};
exports.getFlagPath = getFlagPath;
